var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractPutTask from '@vertical-plus/vue-js-api-platform/dist/model/task/abstract-put-task';
import Exception from '@vertical-plus/vue-js-api-platform/dist/model/exception/exception';
export default class PutUserSettingsTask extends AbstractPutTask {
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute();
            if (response.status === this.successCode) {
                return;
            }
            switch (response.status) {
                case 401:
                    throw new Error(Exception.InvalidDetails);
                default:
                    throw new Error(Exception.UnknownError);
            }
        });
    }
    get url() {
        return `/users/${this.userId}/settings`;
    }
    get data() {
        return this.settings;
    }
}
//# sourceMappingURL=put-user-settings-task.js.map